import { TFunction } from 'i18next';

export const FloorTableColumn = (t: TFunction<'translation', undefined>) => {
    return [
        {
            id: 1,
            key: 'floorName',
            name: t('INVENTORY_ROOM_CONFIG.FLOOR.TABLE_COLUMN.FLOOR_NAME'),
        },
        {
            id: 2,
            key: 'officeName',
            name: t('INVENTORY_ROOM_CONFIG.FLOOR.TABLE_COLUMN.OFFICE_NAME'),
        },
        {
            id: 3,
            key: 'buildingName',
            name: t('INVENTORY_ROOM_CONFIG.FLOOR.TABLE_COLUMN.BUILDING_NAME'),
        },
        {
            id: 4,
            key: 'noOfRoom',
            name: t('INVENTORY_ROOM_CONFIG.FLOOR.TABLE_COLUMN.NO_OF_ROOM'),
        },
    ];
};
